import React from 'react';

import { ConstantPermissions } from 'contexts/useConstant';
import SaleSharedFile from 'components/Tvendo/Sale/Operations/SaleOrder/SaleSharedFile';

export default function DigitateOrder() {
  return (
    <SaleSharedFile
      title="Listado de pedidos digitados"
      excelName="Pedidos_digitados"
      originType="DO"
      permission={{
        show: ConstantPermissions.ORDM_ORDERS_SHOW,
        store: -1,
        edit: ConstantPermissions.ORDM_ORDERS_UPDATE,
      }}
    />
  );
}
